// extracted by mini-css-extract-plugin
export default {"container":"UserProfileComponent_container__deOIS","userDetails":"UserProfileComponent_userDetails__JV+NF","socialIconContainer":"UserProfileComponent_socialIconContainer__ILC5J"};